// extracted by mini-css-extract-plugin
module.exports = {"inputGrid":"input-grid_inputGrid__2U3il","content":"input-grid_content__2-2MQ"};